import React from 'react'

type TermsAndPoliciesSubtitleProps = {
  text: string
}

const TermsAndPoliciesSubtitle = ({ text }: TermsAndPoliciesSubtitleProps) => {
  return (
    <h2 className='text-[#001A3D] text-base md:text-[40px] font-medium md:font-bold md:mb-[40px] max-sm:text-center nb'>
      {text}
    </h2>
  )
}

export default TermsAndPoliciesSubtitle
